import { render, staticRenderFns } from "./MyClassReservation.vue?vue&type=template&id=40d771de&scoped=true&"
import script from "./MyClassReservation.vue?vue&type=script&lang=js&"
export * from "./MyClassReservation.vue?vue&type=script&lang=js&"
import style0 from "./MyClassReservation.vue?vue&type=style&index=0&id=40d771de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d771de",
  null
  
)

export default component.exports